/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./bind-project-tips.vue?vue&type=template&id=7ac93930&"
import script from "./bind-project-tips.vue?vue&type=script&lang=ts&"
export * from "./bind-project-tips.vue?vue&type=script&lang=ts&"
import style0 from "./bind-project-tips.vue?vue&type=style&index=0&id=7ac93930&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports